// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ko-2";
export var container = "_ko-4";
export var dismissButton = "_ko-3";
export var hasPaddingBottom = "_ko-6";
export var last = "_ko-e";
export var scrollbarThumb = "_ko-c";
export var scrollbarTrack = "_ko-b";
export var selected = "_ko-9";
export var spin = "_ko-1";
export var spinning = "_ko-0";
export var suggestionItem = "_ko-d";
export var suggestionsPanel = "_ko-5";
export var tonePill = "_ko-8";
export var tonesContainer = "_ko-7";
export var unselected = "_ko-a";